'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var Vue = _interopDefault(require('vue'));
var ToastOptions = _interopDefault(require('./toast'));

var instance = {
  create: function create() {
    if (!instance.toast) {
      instance.toast = new Vue(_objectSpread({}, ToastOptions, {
        el: document.createElement('div'),
        propsData: {
          onHide: instance.hide
        }
      }));
      document.body.appendChild(instance.toast.$el);
    }
  },
  show: function show() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'loading';
    var text = arguments.length > 1 ? arguments[1] : undefined;
    var config = arguments.length > 2 ? arguments[2] : undefined;
    instance.clear();
    instance.create();
    config = _objectSpread({}, type === 'loading' ? {
      delay: 500
    } : {
      delay: 0,
      duration: 3000
    }, config);
    var className = config.className;
    className && instance.toast.$el.classList.add(className);
    instance.shower = window.setTimeout(function () {
      if ('duration' in config) {
        instance.hider = window.setTimeout(function () {
          instance.hide();
          className && instance.toast.$el.classList.remove(className);
        }, config.duration);
      }

      instance.toast.show = true;
      instance.toast.text = text && text.replace(/\((.*)\)/, '（$1）');
      instance.toast.type = type;
    }, config.delay);
  },
  hide: function hide() {
    instance.clear();
    instance.toast && (instance.toast.show = false);
  },
  clear: function clear() {
    instance.shower && clearTimeout(instance.shower);
    instance.hider && clearTimeout(instance.hider);
  }
};

exports.default = instance;
